import React from 'react';

const PageContainer = ({ children }) => {
	return (
		<section className='container-fluid vh-100'>
			<div className='row'>{children}</div>
		</section>
	);
};

export default PageContainer;
